import i18n from "../../plugins/I18nPlugin";

export function noWhiteSpaceRule(message = "views.PartnerLogin.whiteSpaceRule"): (value: any) => boolean | string {
  return value => value.indexOf(" ") < 0 || String(i18n.tc(message));
}
